export type ScorerDirectoryRecord = {
  id: number; playerName: string; goals: number; penalties: number | null; displayNote?: string;
  tournamentId: number; tournamentSlug: string; tournamentName: string;
  season: string; age: string; clubId: number | null; team: string;
  colors: string[]; logo: string; kitPattern: string;
};
export type ScorerDirectoryGroup = {
  key: string; playerName: string; team: string; age: string; clubId: number | null;
  goals: number; penalties: number | null; tournamentCount: number;
  records: ScorerDirectoryRecord[];
};
export function cleanScorerText(value: string) {
  return value.trim().replace(/\s+/g, " ").toLocaleLowerCase("ru");
}
// Initial punctuation spacing does not identify a different player.
export function formatScorerName(value: string) {
  return value.trim().replace(/\s+/g, " ").replace(/\s*\.\s*/g, ". ").trim();
}
export function scorerNameKey(value: string) {
  return cleanScorerText(formatScorerName(value));
}
// No inferred identity across clubs, initials or age categories.
export function groupScorerRecords(records: ScorerDirectoryRecord[]): ScorerDirectoryGroup[] {
  const groups = new Map<string, ScorerDirectoryGroup>();
  for (const record of records) {
    const teamKey = record.clubId === null ? `name:${cleanScorerText(record.team)}` : `club:${record.clubId}`;
    const key = JSON.stringify([scorerNameKey(record.playerName), teamKey, record.age]);
    let group = groups.get(key);
    if (!group) {
      group = {key, playerName: formatScorerName(record.playerName), team: record.team, age: record.age,
        clubId: record.clubId, goals: 0, penalties: 0, tournamentCount: 0, records: []};
      groups.set(key, group);
    }
    group.records.push(record);
    group.goals += record.goals;
    group.penalties = group.penalties === null || record.penalties === null ? null : group.penalties + record.penalties;
  }
  for (const group of groups.values()) group.tournamentCount = new Set(group.records.map(r => r.tournamentId)).size;
  return [...groups.values()].sort((a,b) => b.goals - a.goals || a.playerName.localeCompare(b.playerName,"ru") || a.team.localeCompare(b.team,"ru"));
}
